import { BoardDTO, TaskDTO } from './tasks';

export enum TaskSubjectEventType {
  CHANGE_CALENDAR_VIEW = 'change-calendar-view',
  UPDATE_TASK = 'update-task',
  CREATE_TASK = 'create-task',
  DELETE_TASK = 'delete-task',
  UPDATE_BOARD = 'update-board',
  FEATURE_DATA_LOADED = 'feature-data-loaded',
  DASHBOARD_FILTER_CHANGES = 'dashboard-filter-changes',
  DASHBOARD_NAVIGATE = 'dashboard_navigate',
}

export enum TaskSubjectEventFeatureType {
  DASHBOARD = 'dashboard',
  TASK_LIST = 'task-list',
  TASK_BOARD = 'task-board',
}

export interface TaskSubjectDeleteTaskEvent {
  taskId: string;
  taskListId: string;
}

export interface TaskSubjectTask extends Omit<TaskDTO, 'id'> {
  uniqueId: string;
}

export interface TaskSubjectChangeCalendarViewEvent {
  isCalendarEnabled: boolean;
  id: 'featureId';
  tasks: TaskSubjectTask[];
  forceTasksUpdate: boolean;
}

export interface TaskSubjectBoard extends Omit<BoardDTO, 'id'> {
  uniqueId: string;
}

export interface TaskSubjectDashboardFilterChanges {
  uniqueId: string;
  tab: 'todo' | 'completed';
  labels: { labelId: string; workspaceId: string }[];
  assigneeIds: string[];
  date: string[];
  workspaceIds: string[];
}

export interface TaskSubjectEvent {
  eventType: TaskSubjectEventType;
  featureType: TaskSubjectEventFeatureType;
  value:
    | TaskSubjectChangeCalendarViewEvent
    | TaskSubjectTask
    | TaskSubjectDeleteTaskEvent
    | TaskSubjectBoard
    | TaskSubjectDashboardFilterChanges;
}

export interface WindowNimbusCommon {
  taskEventsSubj$: {
    subscribe: (callback: (event: TaskSubjectEvent) => void) => void;
  };
}
